"use client";
import {NeoModal} from "@/components/@modal/neo.modal";
import {NeoButton, NeoTextBox} from "@/components/forms";
import {useNeoContext} from "@/context/neo/neo.context";
import type {NextPage} from "next";
import {useState} from "react";

export const Contact: NextPage = function () {
  const {filterContext} = useNeoContext();
  const [modalOpen, setModalOpen] = useState(false);
  const [menuData, setMenuData] = useState(null);
  const formpopup = () => {
    setModalOpen(true);
  };

  const handleClick = () => {
    var userdetails = filterContext.client;
    const message =
      "Name : " +
      userdetails.name +
      ",\nPhone : " +
      userdetails.institutionUserPhone +
      ",\nSchool Name : " +
      userdetails.institutionName +
      "\n*************************" +
      "\nType in your query :";
    const encodedMessage = encodeURIComponent(message);
    const url = `https://wa.me/918428622222?text=${encodedMessage}`;
    window.open(url, "_blank");
  };

  return (
    <>
      <div className="flex min-h-[calc(100vh-63px)] w-full flex-col p-3">
        <div className="grid-cols grid flex-row bg-neo-white ">
          <div className="grid-cols items-center justify-center">
            <img className="" src="/images/contactus.svg" alt="Loading..." />
          </div>
          <div className="grid grid-cols-4 flex-row gap-1">
            <div className="p-5">
              <h4 className="font-bold text-slate-600">Contact Info</h4>
              <p className="pt-5 text-2xl font-bold">
                We are always happy to assist you
              </p>
              <div className="flex">
                <NeoButton
                  className="mx-1 mt-5 bg-[#FFC414]"
                  type="button"
                  onClick={formpopup}
                >
                  Contact Us
                </NeoButton>
              </div>
            </div>
            <div className="p-5">
              <h4 className="font-bold">Email Address</h4>
              <h4 className="mt-0">
                <img className="" src="/icons/Rectangle.svg" alt="Loading..." />
              </h4>
              <h3 className="pt-2 font-bold">
                <a href="mailto:support@neotrack.ai" target="_blank">
                  support@neotrack.ai
                </a>
              </h3>
              <p className="pt-2">Assistance hours: </p>
              <p>Monday - Friday 6 am to</p>
              <p>8 pm IST</p>
            </div>
            <div className="p-5">
              <h4 className="font-bold">Website</h4>
              <h4 className="mt-0">
                <img className="" src="/icons/Rectangle.svg" alt="Loading..." />
              </h4>
              <h3 className="pt-2 font-bold">
                <a
                  href="https://neotrack.ai/"
                  target="_blank"
                  title="www.neotrack.ai"
                >
                  www.neotrack.ai
                </a>
              </h3>
            </div>
            <div className="p-5">
              <h4 className="font-bold">Our Presence</h4>
              <h4 className="mt-0">
                <img className="" src="/icons/Rectangle.svg" alt="Loading..." />
              </h4>
              <div className="pt-2">
                <h3 className="text-slate-600">Bangalore</h3>
                <p className="mt-1 font-bold">9th Main, 7th Sector,</p>
                <p className="font-bold">HSRR Layout, Bangalore,</p>
                <p className="font-bold">Karnataka - 560102.</p>
              </div>
              <div className="pt-5">
                <h3 className="text-slate-600">Coimbatore</h3>
                <p className="mt-1 font-bold">3rd Floor, NO - 114 E3,</p>
                <p className="font-bold">Mariammal Towers,</p>
                <p className="font-bold">Racecourse, Coimbatore,</p>
                <p className="font-bold">Tamilnadu - 641018.</p>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 flex-row bg-[#FFC414] ">
            <div className="p-14">
              <h4 className="pt-2 text-2xl font-bold text-neo-black">
                Subscribe to our Newsletter
              </h4>
              <p className="text-justify text-neo-black">
                Subscribe for Updates: Stay informed about the latest investor
                updates, financial results, and announcements by subscribing to
                our newsletter.
              </p>
            </div>
            <div className="p-14">
              <div className="flex items-center border-0 py-2">
                <NeoTextBox
                  className="w-60 focus:!outline-none"
                  placeholder="Enter your email"
                />
                <NeoButton
                  className="ml-1 w-20 bg-[#FFFFFF] text-[#000000]"
                  type="button"
                >
                  Subscribee
                </NeoButton>
              </div>
            </div>
          </div>
          <div className="flex items-center justify-center border-0 bg-[#F4F7FE] py-2">
            <a onClick={handleClick} className="cursor-pointer">
              <img
                className="border-b-2 border-[#A6A6A6]"
                src="/icons/whatsapp.svg"
                alt="Loading..."
              />
            </a>
            <a href="https://www.facebook.com/neotrackweb/" target="_blank">
              <img
                className="border-b-2 border-[#A6A6A6]"
                src="/icons/facebook.svg"
                alt="Loading..."
              />
            </a>
            <a href="https://www.instagram.com/neotrack.ai" target="_blank">
              <img
                className="border-b-2 border-[#A6A6A6]"
                src="/icons/instagram.svg"
                alt="Loading..."
              />
            </a>
            <a href="https://in.linkedin.com/company/neotrack" target="_blank">
              <img
                className="border-b-2 border-[#A6A6A6]"
                src="/icons/linked.svg"
                alt="Loading..."
              />
            </a>
            <a href="mailto:support@neotrack.ai" target="_blank">
              <img
                className="border-b-2 border-[#A6A6A6]"
                src="/icons/email.svg"
                alt="Loading..."
              />
            </a>
            <a href="https://x.com/neotrackweb" target="_blank">
              <img
                className="border-b-2 border-[#A6A6A6]"
                src="/icons/twitter.svg"
                alt="Loading..."
              />
            </a>
          </div>
        </div>
        {/*<div className="p-2">
          <div className="mb-4 flex-row px-3">
            <NeoHeader message="Contact Us"></NeoHeader>
          </div>
          <div className="flex font-semibold">
            <NeoCard>
              <CardBody className="flex-row font-semibold flex-col-2">
                <div className="w-6/12">
                  <div className="flex flex-col">
                    <h4 className="p-4 text-sm font-medium  mb-2 block text-gray-500">
                      You can get in touch with us through below platforms. Our Team will reach out to you as soon as possible.
                    </h4>
                  </div>
                  <div className="flex flex-col-2">
                    <div className="p-4">
                      <svg 
                        fill="#ffc727" 
                        width="32" 
                        height="32"
                        viewBox="0 0 1920 1920" 
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="23.04"></g>
                        <g id="SVGRepo_iconCarrier"> 
                          <path 
                            d="M1688.412 1807.059H332.059v-326.275h56.515c31.196 0 56.514-25.299 56.514-56.47 0-31.172-25.318-56.47-56.514-56.47h-56.515V1029.02h56.515c31.196 0 56.514-25.3 56.514-56.471 0-31.172-25.318-56.47-56.514-56.47h-56.515V577.254h56.515c31.196 0 56.514-25.299 56.514-56.47 0-31.172-25.318-56.471-56.514-56.471h-56.515V112.942h1356.353v1694.117ZM219.029 0v464.314h-56.514c-31.196 0-56.515 25.299-56.515 56.47 0 31.172 25.319 56.47 56.515 56.47h56.514v338.824h-56.514c-31.196 0-56.515 25.3-56.515 56.471 0 31.172 25.319 56.47 56.515 56.47h56.514v338.824h-56.514c-31.196 0-56.515 25.299-56.515 56.47 0 31.172 25.319 56.471 56.515 56.471h56.514V1920h1582.412V0H219.03ZM1029 499c112.782 0 226.444 91.718 226.444 204.5v102.25c0 44.99-22.423 87.424-47.167 121.269 40.798 9.611 66.225 21.165 105.285 38.037 75.563 32.72 124.438 106.646 124.438 188.446v140.799l-24.029 15.03c-69.632 43.457-207.772 111.862-386.607 111.862-17.485 0-35.174-.716-53.375-2.045-116.053-8.896-230.164-46.933-330.165-110.021L620 1294.096v-139.98c0-81.902 49.163-152.712 122.495-187.629 40.64-19.35 59.25-30.087 91.408-39.468-25.255-34.05-41.383-75.665-41.383-121.269V703.5C792.52 590.718 916.218 499 1029 499Zm-10.58 510.61c-80.062 1.432-159 18.1-235.278 51.126-37.014 15.95-60.839 52.76-60.839 93.763v82.925c79.96 45.603 169.122 73.21 259.51 80.164 156.034 11.759 281.904-39.98 353.99-80.369v-83.333c0-41.003-24.642-78.12-62.679-94.582-63.088-27.198-129.346-43.66-196.831-48.773-13.19-1.022-26.278-.511-39.469-.716-1.329.052-5.036.026-8.857-.025l-.918-.013-.916-.013c-3.192-.05-6.21-.11-7.714-.153Zm10.74-408.307c-56.442 0-141.022 45.91-141.022 102.25v102.25c0 55.113 82.842 99.592 137.545 101.535 2.148 0 4.295.102 6.442.102 54.908-1.636 128.086-46.32 128.086-101.637v-102.25c0-56.34-74.61-102.25-131.051-102.25Z" 
                            fillRule="evenodd"
                          />
                        </g>
                      </svg>
                    </div>
                    <div className="mt-3">
                      <h4 className="mb-1 text-sm font-medium block text-gray-500">
                        Our Location
                      </h4>
                      <div className="p-2">
                        <h4 className="text-sm font-medium block text-gray-700">
                          Bangalore
                        </h4>
                        <p className="text-base text-sm text-body-color">
                          #1207/343 & 1207/1/343/1, 9th Main,<br/>7th Sector HSR Layout, Bangalore,<br/>Karnataka – 560102
                        </p>
                      </div>
                      <div className="p-2">
                        <h4 className="text-sm font-medium block text-gray-700">
                          Coimbatore
                        </h4>
                        <p className="text-base text-sm text-body-color">
                          3rd Floor, NO -114 E3, Mariammal Towers,<br/>Race Course,Coimbatore,<br/>Tamil Nadu – 641018.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col-2">
                    <div className="p-4">
                      <svg 
                        width="32" 
                        height="32" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                        <g id="SVGRepo_iconCarrier"> 
                          <path 
                            fillRule="evenodd" 
                            clipRule="evenodd" 
                            d="M3.75 5.25L3 6V18L3.75 18.75H20.25L21 18V6L20.25 5.25H3.75ZM4.5 7.6955V17.25H19.5V7.69525L11.9999 14.5136L4.5 7.6955ZM18.3099 6.75H5.68986L11.9999 12.4864L18.3099 6.75Z" 
                            fill="#ffc727"
                          />
                        </g>
                      </svg>
                    </div>
                    <div className="mt-5">
                      <h4 className="mb-1 text-sm font-medium text-gray-500">
                        Email Address
                      </h4>
                      <p className="text-base text-body-color ">
                        support@neotrack.ai
                      </p>
                    </div>
                  </div>
                  <div className="flex flex-col-2">
                    <div className="p-4">
                      <svg 
                        width="32" 
                        height="32" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        xmlns="http://www.w3.org/2000/svg" 
                        stroke="#ffc727" 
                        stroke-width="0.00024000000000000003"
                      >
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.096"></g>
                        <g id="SVGRepo_iconCarrier"> 
                          <g id="style=linear" clip-path="url(#clip0_1_1825)"> 
                            <g id="web"> 
                              <path 
                                id="vector" 
                                d="M7.8 12L7.05 12L7.8 12ZM16.2 12H16.95H16.2ZM12 16.2V16.95V16.2ZM14.1729 22.2749L14.3273 23.0088L14.1729 22.2749ZM9.82712 22.2749L9.67269 23.0088L9.82712 22.2749ZM2.27554 8.03225L1.58122 7.74867H1.58122L2.27554 8.03225ZM1.7251 14.1729L0.991173 14.3273L1.7251 14.1729ZM9.82712 1.7251L9.67269 0.991173L9.82712 1.7251ZM14.1729 1.7251L14.3273 0.991174L14.1729 1.7251ZM21.6399 8.07014L21.8576 8.78785L21.6399 8.07014ZM2.35887 8.06976L2.14116 8.78747L2.35887 8.06976ZM21.0312 8.3185C21.4944 9.45344 21.75 10.6959 21.75 12H23.25C23.25 10.4983 22.9553 9.06352 22.42 7.75174L21.0312 8.3185ZM21.75 12C21.75 12.6927 21.6779 13.3678 21.541 14.0184L23.0088 14.3273C23.167 13.5757 23.25 12.7972 23.25 12H21.75ZM21.541 14.0184C20.7489 17.7827 17.7828 20.7489 14.0184 21.541L14.3273 23.0088C18.6735 22.0943 22.0943 18.6735 23.0088 14.3273L21.541 14.0184ZM14.0184 21.541C13.3678 21.6779 12.6927 21.75 12 21.75V23.25C12.7972 23.25 13.5757 23.167 14.3273 23.0088L14.0184 21.541ZM12 21.75C11.3072 21.75 10.6322 21.6779 9.98156 21.541L9.67269 23.0088C10.4242 23.167 11.2028 23.25 12 23.25V21.75ZM2.25 12C2.25 10.6949 2.50601 9.45149 2.96986 8.31584L1.58122 7.74867C1.0451 9.06127 0.75 10.4971 0.75 12H2.25ZM9.98156 21.541C6.21724 20.7489 3.25112 17.7827 2.45903 14.0184L0.991173 14.3273C1.90571 18.6735 5.32647 22.0943 9.67269 23.0088L9.98156 21.541ZM2.45903 14.0184C2.32213 13.3678 2.25 12.6927 2.25 12H0.75C0.75 12.7972 0.83303 13.5757 0.991173 14.3273L2.45903 14.0184ZM2.96986 8.31584C4.17707 5.36016 6.79381 3.1298 9.98155 2.45903L9.67269 0.991173C5.99032 1.76602 2.97369 4.33941 1.58122 7.74867L2.96986 8.31584ZM9.98155 2.45903C10.6322 2.32213 11.3072 2.25 12 2.25V0.75C11.2028 0.75 10.4242 0.83303 9.67269 0.991173L9.98155 2.45903ZM12 2.25C12.6927 2.25 13.3678 2.32213 14.0184 2.45903L14.3273 0.991174C13.5757 0.833031 12.7972 0.75 12 0.75V2.25ZM14.0184 2.45903C17.2071 3.13 19.8245 5.3615 21.0312 8.3185L22.42 7.75174C21.0281 4.34096 18.0108 1.76625 14.3273 0.991174L14.0184 2.45903ZM13.4584 1.95309C13.7482 2.8614 14.8215 6.35621 15.2615 9.5682L16.7476 9.36461C16.289 6.01664 15.1813 2.41835 14.8874 1.49712L13.4584 1.95309ZM15.2615 9.5682C15.3795 10.4292 15.45 11.2568 15.45 12L16.95 12C16.95 11.1681 16.8715 10.269 16.7476 9.36461L15.2615 9.5682ZM21.4222 7.35242C20.2692 7.70212 18.1033 8.3164 15.8685 8.72886L16.1407 10.204C18.4546 9.7769 20.6809 9.14473 21.8576 8.78785L21.4222 7.35242ZM15.8685 8.72886C14.5129 8.97904 13.1579 9.15 12 9.15L12 10.65C13.2874 10.65 14.743 10.4619 16.1407 10.204L15.8685 8.72886ZM15.45 12C15.45 13.1009 15.2954 14.3808 15.0647 15.671L16.5413 15.935C16.7797 14.6019 16.95 13.2252 16.95 12L15.45 12ZM15.0647 15.671C14.5591 18.4992 13.7097 21.2593 13.4584 22.0469L14.8874 22.5029C15.145 21.6956 16.0181 18.8613 16.5413 15.935L15.0647 15.671ZM22.0469 13.4584C21.2593 13.7097 18.4992 14.5591 15.671 15.0647L15.935 16.5413C18.8613 16.0181 21.6956 15.145 22.5029 14.8874L22.0469 13.4584ZM15.671 15.0647C14.3808 15.2954 13.1009 15.45 12 15.45L12 16.95C13.2252 16.95 14.6019 16.7797 15.935 16.5413L15.671 15.0647ZM12 15.45C10.8991 15.45 9.61923 15.2954 8.32897 15.0647L8.06496 16.5413C9.39807 16.7797 10.7748 16.95 12 16.95L12 15.45ZM8.32897 15.0647C5.50076 14.5591 2.74066 13.7097 1.95309 13.4584L1.49712 14.8874C2.30437 15.145 5.13873 16.0181 8.06496 16.5413L8.32897 15.0647ZM7.05 12C7.05 13.2252 7.22032 14.6019 7.45867 15.935L8.93526 15.671C8.70456 14.3808 8.55 13.1009 8.55 12L7.05 12ZM7.45867 15.935C7.98188 18.8613 8.85504 21.6956 9.11261 22.5029L10.5416 22.0469C10.2903 21.2593 9.44094 18.4992 8.93526 15.671L7.45867 15.935ZM9.11261 1.49712C8.81867 2.41835 7.711 6.01664 7.25235 9.36461L8.73846 9.5682C9.17849 6.35621 10.2518 2.8614 10.5416 1.95309L9.11261 1.49712ZM7.25235 9.36461C7.12846 10.269 7.05 11.1681 7.05 12L8.55 12C8.55 11.2568 8.62052 10.4292 8.73846 9.5682L7.25235 9.36461ZM12 9.15C10.8421 9.15 9.4871 8.97904 8.13152 8.72886L7.85929 10.204C9.25697 10.4619 10.7126 10.65 12 10.65L12 9.15ZM8.13152 8.72886C5.89586 8.31625 3.72921 7.70168 2.57657 7.35205L2.14116 8.78747C3.3175 9.14428 5.54457 9.77675 7.85929 10.204L8.13152 8.72886ZM21.38 7.3695C21.3919 7.3633 21.4065 7.35719 21.4222 7.35242L21.8576 8.78785C21.933 8.76498 22.0039 8.73569 22.0712 8.70074L21.38 7.3695ZM1.88425 8.67209C1.96322 8.72038 2.04888 8.75948 2.14116 8.78747L2.57657 7.35205C2.60983 7.36214 2.64048 7.3763 2.66683 7.39242L1.88425 8.67209Z" 
                                fill="#ffc727"
                              />
                            </g>
                          </g> 
                          <defs> 
                            <clipPath id="clip0_1_1825"> 
                              <rect width="24" height="24" fill="white"></rect> 
                            </clipPath> 
                          </defs>
                        </g>
                      </svg>
                    </div>
                    <div className="mt-4">
                      <h4 className="mb-1 text-sm font-medium  block text-gray-500">
                        Web Address
                      </h4>
                      <p className="font-medium">
                        <a href="https://neotrack.ai/" target="_blank">https://neotrack.ai</a>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="w-6/12">
                  <div className="flex flex-col">
                    <h4 className="p-4 text-sm font-medium mb-10 block text-gray-500"></h4>
                  </div>
                  <div className="flex flex-col-2">
                    <div className="p-4">
                      <svg 
                        width="32" 
                        height="32" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        xmlns="http://www.w3.org/2000/svg" 
                        stroke="#ffc727" stroke-width="0.00024000000000000003"
                      >
                        <g id="SVGRepo_bgCarrier" stroke-width="0"/>
                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>
                        <g id="SVGRepo_iconCarrier"> 
                          <path 
                            fillRule="evenodd" 
                            clipRule="evenodd" 
                            d="M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z" fill="#ffc727"/> <path d="M18 5C17.4477 5 17 5.44772 17 6C17 6.55228 17.4477 7 18 7C18.5523 7 19 6.55228 19 6C19 5.44772 18.5523 5 18 5Z" fill="#ffc727"/> <path fillRule="evenodd" clipRule="evenodd" d="M1.65396 4.27606C1 5.55953 1 7.23969 1 10.6V13.4C1 16.7603 1 18.4405 1.65396 19.7239C2.2292 20.8529 3.14708 21.7708 4.27606 22.346C5.55953 23 7.23969 23 10.6 23H13.4C16.7603 23 18.4405 23 19.7239 22.346C20.8529 21.7708 21.7708 20.8529 22.346 19.7239C23 18.4405 23 16.7603 23 13.4V10.6C23 7.23969 23 5.55953 22.346 4.27606C21.7708 3.14708 20.8529 2.2292 19.7239 1.65396C18.4405 1 16.7603 1 13.4 1H10.6C7.23969 1 5.55953 1 4.27606 1.65396C3.14708 2.2292 2.2292 3.14708 1.65396 4.27606ZM13.4 3H10.6C8.88684 3 7.72225 3.00156 6.82208 3.0751C5.94524 3.14674 5.49684 3.27659 5.18404 3.43597C4.43139 3.81947 3.81947 4.43139 3.43597 5.18404C3.27659 5.49684 3.14674 5.94524 3.0751 6.82208C3.00156 7.72225 3 8.88684 3 10.6V13.4C3 15.1132 3.00156 16.2777 3.0751 17.1779C3.14674 18.0548 3.27659 18.5032 3.43597 18.816C3.81947 19.5686 4.43139 20.1805 5.18404 20.564C5.49684 20.7234 5.94524 20.8533 6.82208 20.9249C7.72225 20.9984 8.88684 21 10.6 21H13.4C15.1132 21 16.2777 20.9984 17.1779 20.9249C18.0548 20.8533 18.5032 20.7234 18.816 20.564C19.5686 20.1805 20.1805 19.5686 20.564 18.816C20.7234 18.5032 20.8533 18.0548 20.9249 17.1779C20.9984 16.2777 21 15.1132 21 13.4V10.6C21 8.88684 20.9984 7.72225 20.9249 6.82208C20.8533 5.94524 20.7234 5.49684 20.564 5.18404C20.1805 4.43139 19.5686 3.81947 18.816 3.43597C18.5032 3.27659 18.0548 3.14674 17.1779 3.0751C16.2777 3.00156 15.1132 3 13.4 3Z" 
                            fill="#ffc727"
                          /> 
                        </g>
                      </svg>
                    </div>
                    <div className="mt-4">
                      <h4 className="mb-1 text-sm font-medium block text-gray-500">
                        Instagram
                      </h4>
                      <p className="font-medium">
                        <a href="https://www.instagram.com/neotrack.ai/" target="_blank">https://www.instagram.com/neotrack.ai</a>
                      </p>
                    </div>
                  </div>
                  <div className="flex flex-col-2">
                    <div className="p-4">
                      <svg 
                        width="32" 
                        height="32" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        xmlns="http://www.w3.org/2000/svg" 
                        stroke="#ffc727" 
                        stroke-width="0.00024000000000000003" 
                        transform="matrix(1, 0, 0, 1, 0, 0)"
                      >
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#ffc727" stroke-width="0.048"></g>
                        <g id="SVGRepo_iconCarrier"> 
                          <path 
                            fillRule="evenodd" 
                            clipRule="evenodd" 
                            d="M20 1C21.6569 1 23 2.34315 23 4V20C23 21.6569 21.6569 23 20 23H4C2.34315 23 1 21.6569 1 20V4C1 2.34315 2.34315 1 4 1H20ZM20 3C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H15V13.9999H17.0762C17.5066 13.9999 17.8887 13.7245 18.0249 13.3161L18.4679 11.9871C18.6298 11.5014 18.2683 10.9999 17.7564 10.9999H15V8.99992C15 8.49992 15.5 7.99992 16 7.99992H18C18.5523 7.99992 19 7.5522 19 6.99992V6.31393C19 5.99091 18.7937 5.7013 18.4813 5.61887C17.1705 5.27295 16 5.27295 16 5.27295C13.5 5.27295 12 6.99992 12 8.49992V10.9999H10C9.44772 10.9999 9 11.4476 9 11.9999V12.9999C9 13.5522 9.44771 13.9999 10 13.9999H12V21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20Z" 
                            fill="#ffc727"
                          />
                        </g>
                      </svg>
                    </div>
                    <div className="mt-4">
                      <h4 className="mb-1 text-sm font-medium block text-gray-500">
                        Facebook
                      </h4>
                      <p className="font-medium">
                        <a href="https://www.facebook.com/neotrackweb/" target="_blank">https://www.facebook.com/neotrackweb</a>
                      </p>
                    </div>
                  </div>
                  <div className="flex flex-col-2">
                    <div className="pt-4 pb-4 pl-5 pr-3">
                      <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        width="32" 
                        height="32" 
                        fill="#ffc727" 
                        viewBox="0 0 24 24"
                      >
                        <path 
                          d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"
                          fill="#ffc727"
                        />
                      </svg>
                    </div>
                    <div className="mr-1 mt-4">
                      <h4 className="mb-1 text-sm font-medium  block text-gray-500">
                        Twitter
                      </h4>
                      <p className="font-medium">
                        <a href="https://x.com/neotrackweb" target="_blank">https://x.com/neotrackweb</a>
                      </p>
                    </div>
                  </div>
                  <div className="flex flex-col-2">
                    <div className="p-4">
                      <svg 
                        width="32" 
                        height="32" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        xmlns="http://www.w3.org/2000/svg" 
                        stroke="#ffc727" 
                        stroke-width="0.00024000000000000003"
                      >
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.048"></g>
                        <g id="SVGRepo_iconCarrier"> 
                          <path 
                            fillRule="evenodd" 
                            clipRule="evenodd" 
                            d="M9.49614 7.13176C9.18664 6.9549 8.80639 6.95617 8.49807 7.13509C8.18976 7.31401 8 7.64353 8 8V16C8 16.3565 8.18976 16.686 8.49807 16.8649C8.80639 17.0438 9.18664 17.0451 9.49614 16.8682L16.4961 12.8682C16.8077 12.6902 17 12.3589 17 12C17 11.6411 16.8077 11.3098 16.4961 11.1318L9.49614 7.13176ZM13.9844 12L10 14.2768V9.72318L13.9844 12Z" fill="#ffc727"></path> <path fillRule="evenodd" clipRule="evenodd" d="M0 12C0 8.25027 0 6.3754 0.954915 5.06107C1.26331 4.6366 1.6366 4.26331 2.06107 3.95491C3.3754 3 5.25027 3 9 3H15C18.7497 3 20.6246 3 21.9389 3.95491C22.3634 4.26331 22.7367 4.6366 23.0451 5.06107C24 6.3754 24 8.25027 24 12C24 15.7497 24 17.6246 23.0451 18.9389C22.7367 19.3634 22.3634 19.7367 21.9389 20.0451C20.6246 21 18.7497 21 15 21H9C5.25027 21 3.3754 21 2.06107 20.0451C1.6366 19.7367 1.26331 19.3634 0.954915 18.9389C0 17.6246 0 15.7497 0 12ZM9 5H15C16.9194 5 18.1983 5.00275 19.1673 5.10773C20.0989 5.20866 20.504 5.38448 20.7634 5.57295C21.018 5.75799 21.242 5.98196 21.4271 6.23664C21.6155 6.49605 21.7913 6.90113 21.8923 7.83269C21.9973 8.80167 22 10.0806 22 12C22 13.9194 21.9973 15.1983 21.8923 16.1673C21.7913 17.0989 21.6155 17.504 21.4271 17.7634C21.242 18.018 21.018 18.242 20.7634 18.4271C20.504 18.6155 20.0989 18.7913 19.1673 18.8923C18.1983 18.9973 16.9194 19 15 19H9C7.08058 19 5.80167 18.9973 4.83269 18.8923C3.90113 18.7913 3.49605 18.6155 3.23664 18.4271C2.98196 18.242 2.75799 18.018 2.57295 17.7634C2.38448 17.504 2.20866 17.0989 2.10773 16.1673C2.00275 15.1983 2 13.9194 2 12C2 10.0806 2.00275 8.80167 2.10773 7.83269C2.20866 6.90113 2.38448 6.49605 2.57295 6.23664C2.75799 5.98196 2.98196 5.75799 3.23664 5.57295C3.49605 5.38448 3.90113 5.20866 4.83269 5.10773C5.80167 5.00275 7.08058 5 9 5Z" 
                            fill="#ffc727"
                          />
                        </g>
                      </svg>
                    </div>
                    <div className="mr-1 mt-4">
                      <h4 className="mb-1 text-sm font-medium block text-gray-500">
                        Youtube
                      </h4>
                      <p className="font-medium">
                        <a href="https://www.youtube.com/@neotrack_tech" target="_blank">https://www.youtube.com/@neotrack_tech</a>
                      </p>
                    </div>
                  </div>
                </div>
              </CardBody>
            </NeoCard>
          </div>
        </div>*/}
      </div>
      <NeoModal
        onOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        actionType={"contactform"}
        hasActions={false}
      ></NeoModal>
    </>
  );
};
